// extracted by mini-css-extract-plugin
export default {"soundTracks":"SoundTracks_soundTracks__7rG77","contentTitle":"SoundTracks_contentTitle__ztVuw","content":"SoundTracks_content__r0RPv","backButton":"SoundTracks_backButton__-cosA"};